<template>
  <div>
    <AccountsHeader
      class="mx-5 mt-8"
      :showFilter="showFilter"
      :hideFilterOptions="hideFilterOptions"
      @filterChange="filterChange"
    />
    <v-tabs class="pa-5" background-color="transparent" color="#0439D9" slider-size="1">
      <v-tab @click="showFilter = true" class="tabItem">Dashboard</v-tab>
      <v-tab @click="updateFilter()" class="tabItem">Busca</v-tab>
      <v-tab-item>
        <AccountsInfoPanel class="mx-5 mt-8" :accounts="accounts" :filterActive="filter" />
        <AccountsChartPanel class="mx-5 mt-3" :accounts="accounts" />
      </v-tab-item>
      <v-tab-item>
        <AccountsSearchPanel class="mx-5 mt-8" />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import AccountsHeader from "@/components/organisms/Contas/accounts-header";
import AccountsInfoPanel from "@/components/organisms/Contas/accounts-info-panel";
import AccountsChartPanel from "@/components/organisms/Contas/accounts-charts-panel";
import AccountsSearchPanel from "@/components/organisms/Contas/accounts-search-panel";

export default {
  components: {
    AccountsHeader,
    AccountsInfoPanel,
    AccountsChartPanel,
    AccountsSearchPanel
  },
  data() {
    return {
      filter: null,
      hideFilterOptions: false,
      showFilter: true
    };
  },
  methods: {
    filterChange(value) {
      this.filter = value;
    },
    updateFilter() {
      this.showFilter = false;
      this.filter = false;
      this.$store.dispatch("resetFilters", { filter: "contas" });
      this.hideFilterOptions = !this.hideFilterOptions;
    }
  },
  computed: {
    accounts() {
      return this.$store.getters.accounts;
    }
  }
};
</script>

<style scoped>
.tabItem {
  width: 158px;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
}

.v-tab {
  text-transform: none !important;
}
</style>